import request from "@/utils/request";

export const queryMonitorStats = (data, options = {}) => {
  return request({
    url: "/monitors/statistics",
    method: "post",
    data,
    ...options,
  });
};

export const queryMonitorList = (data, options = {}) => {
  return request({
    url: "/monitors",
    method: "post",
    data,
    ...options,
  });
};

export const createMonitor = (data, options = {}) => {
  return request({
    url: "/monitors/create",
    method: "post",
    data,
    ...options,
  });
};

export const validateMonitorWebhook = (data, options = {}) => {
  return request({
    url: "/monitors/webhook/validate",
    method: "post",
    data,
    ...options,
  });
};

export const lookupMonitor = (data, options = {}) => {
  return request({
    url: "/monitors/lookup",
    method: "post",
    data,
    ...options,
  });
};

export const duplicateMonitor = (data, options = {}) => {
  return request({
    url: "/monitors/duplicate",
    method: "post",
    data,
    ...options,
  });
};

export const deleteMonitor = (data, options = {}) => {
  return request({
    url: "/monitors/delete",
    method: "delete",
    data,
    ...options,
  });
};

export const revealMonitorSignature = (data, options = {}) => {
  return request({
    url: "/monitors/signature/reveal",
    method: "post",
    data,
    ...options,
  });
};

export const updateMonitor = (data, options = {}) => {
  return request({
    url: "/monitors/update",
    method: "post",
    data,
    ...options,
  });
};

export const queryDetailMonitorLogs = (data, options = {}) => {
  return request({
    url: "/monitors/statistics/logs",
    method: "post",
    data,
    ...options,
  });
};

export const lookupDetailMonitorLog = (data, options = {}) => {
  return request({
    url: "/monitors/statistics/logs/lookup",
    method: "post",
    data,
    ...options,
  });
};

export const retryDetailMonitorLog = (data, options = {}) => {
  return request({
    url: "/monitors/process/retry",
    method: "post",
    data,
    ...options,
  });
};

export const retryDetailMonitorLogBatch = (data, options = {}) => {
  return request({
    url: "/monitors/process/batch/retry",
    method: "post",
    data,
    ...options,
  });
};

export const exportDetailMonitorLogs = (data, options = {}) => {
  return request({
    url: "/monitors/statistics/logs/export",
    method: "post",
    data,
    ...options,
  });
};

export const exportMonitorData = (data, options = {}) => {
  return request({
    url: "/monitors/statistics/data/export",
    method: "post",
    data,
    ...options,
  });
};

export const getMonitorFilterConfig = (data, options = {}) => {
  return request({
    url: "/monitors/filters",
    method: "get",
    data,
    ...options,
  });
};

export const getMonitorTemplates = (data, options = {}) => {
  return request({
    url: "/monitors/templates",
    method: "get",
    data,
    ...options,
  });
};

export const runMonitorTest = (data, options = {}) => {
  return request({
    url: "/monitors/process/try",
    method: "post",
    data,
    ...options,
  });
};

export const getMonitorParamsEnrichment = (data, options = {}) => {
  return request({
    url: "/monitors/parameters/enrichment",
    method: "post",
    data,
    ...options,
  });
};
